import { z } from 'zod';

export const insightsGroupRowSchema = z.object({
  key: z.string(),
  label: z.string(),
  count: z.number(),
  avgCycleTimeDays: z.number().nullable(),
  avgAgeDays: z.number().nullable(),
});

export type InsightsGroupRow = z.infer<typeof insightsGroupRowSchema>;
